import React from "react";
import { Users } from "lucide-react";
import type { UserStatusSummary } from "../../../types/dashboard";
import {
  Overlay,
  Content,
  IconWrapper,
  Title,
  Subtitle,
  AccountList,
  AccountCard,
  AccountAvatar,
  AccountInfo,
  AccountName,
  AccountPhone,
  ErrorMessage,
  Spinner,
} from "./index.styled";

interface AccountSelectorProps {
  isVisible: boolean;
  statuses: UserStatusSummary[];
  loading: boolean;
  error: string | null;
  onSelect: (statusId: number) => void;
  onRetry: () => void;
}

const AccountSelector: React.FC<AccountSelectorProps> = ({
  isVisible,
  statuses,
  loading,
  error,
  onSelect,
  onRetry,
}) => {
  if (!isVisible) return null;

  return (
    <Overlay>
      <Content onClick={(e) => e.stopPropagation()}>
        <IconWrapper>
          <Users size={24} color="white" />
        </IconWrapper>

        <Title>בחר חשבון</Title>
        <Subtitle>לאיזה חשבון תרצה להתחבר?</Subtitle>

        {loading && <Spinner />}

        {error && (
          <>
            <ErrorMessage>{error}</ErrorMessage>
            <button
              onClick={onRetry}
              style={{
                marginTop: 12,
                padding: "8px 20px",
                border: "none",
                borderRadius: 10,
                background: "#007AFF",
                color: "white",
                fontFamily: '"Noto Sans Hebrew", sans-serif',
                fontSize: 14,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              נסה שוב
            </button>
          </>
        )}

        {!loading && !error && statuses.length > 0 && (
          <AccountList>
            {statuses.map((status) => (
              <AccountCard key={status.id} onClick={() => onSelect(status.id)}>
                <AccountAvatar $src={status.image}>
                  {!status.image && status.name.charAt(0)}
                </AccountAvatar>
                <AccountInfo>
                  <AccountName>{status.name}</AccountName>
                  {status.phone && <AccountPhone>{status.phone}</AccountPhone>}
                </AccountInfo>
              </AccountCard>
            ))}
          </AccountList>
        )}
      </Content>
    </Overlay>
  );
};

export default AccountSelector;
